export default __webpack_public_path__ + "img/fiat-logo.ffd1719e.png";